import { PricesPage } from "pages/management/Prices";
import { Route, Switch } from "react-router-dom";

const ManagementRoutes = () => (
    <Switch>
        <Route exact path="/management/prices" component={PricesPage} />
    </Switch>
);

export default ManagementRoutes;
